module.exports = __webpack_public_path__ + "img/booming-games.bfd54958.svg";